import React from 'react';

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const DailyPocketLogo: React.FC<LogoProps> = ({ width = 40, height = 40, className = "" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background Circle */}
      <circle cx="20" cy="20" r="18" fill="url(#gradient)" stroke="#fff" strokeWidth="2"/>
      
      {/* Pocket Shape */}
      <path
        d="M12 14 C12 12, 14 10, 16 10 L24 10 C26 10, 28 12, 28 14 L28 26 C28 28, 26 30, 24 30 L16 30 C14 30, 12 28, 12 26 Z"
        fill="#4A5568"
        stroke="#2D3748"
        strokeWidth="1"
      />
      
      {/* Pocket Opening */}
      <rect x="14" y="10" width="12" height="4" fill="#2D3748" rx="2"/>
      
      {/* Coins */}
      <circle cx="18" cy="20" r="3" fill="#F6E05E" stroke="#D69E2E" strokeWidth="1"/>
      <circle cx="22" cy="23" r="2.5" fill="#F6E05E" stroke="#D69E2E" strokeWidth="1"/>
      
      {/* Coin Details */}
      <text x="18" y="22" fontSize="3" fill="#B7791F" textAnchor="middle" fontWeight="bold">¥</text>
      <text x="22" y="24.5" fontSize="2.5" fill="#B7791F" textAnchor="middle" fontWeight="bold">$</text>
      
      {/* Sparkle Effects */}
      <circle cx="14" cy="16" r="1" fill="#FFF" opacity="0.8"/>
      <circle cx="26" cy="18" r="0.8" fill="#FFF" opacity="0.6"/>
      <circle cx="25" cy="12" r="0.6" fill="#FFF" opacity="0.9"/>
      
      {/* Gradient Definition */}
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#667eea"/>
          <stop offset="100%" stopColor="#764ba2"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DailyPocketLogo;